import React, { useState } from "react";
import { AlertTriangle } from "lucide-react";
import "./Analytics.css";

// Architecture Layers
import { useAnalyticsData } from "../hooks/useAnalyticsData";

// Modular Components
import AnalyticsHeader from "../components/AnalyticsHeader";
import KPIStatsGrid from "../components/KPIStatsGrid";
import ChartsGrid from "../components/ChartsGrid";
import PerformersTable from "../components/PerformersTable";

/**
 * Analytics Page (Orchestrator)
 * Follows Atomic Feature Architecture: Logic in Hooks, API in Services.
 * File strictly adheres to < 300 line limit.
 */
import AnalyticsSkeleton from "../components/Skeletons/AnalyticsSkeleton";

const Analytics = () => {
    const [timeRange, setTimeRange] = useState("Last 30 Days");
    
    // Logic & State Layer
    const {
        loading,
        error,
        trends,
        metrics,
        team,
        isExporting,
        handleExport
    } = useAnalyticsData(timeRange);

    if (loading && !trends) {
        return <AnalyticsSkeleton />;
    }

    return (
        <div className="analytics-page">
            {/* Header with Filters & Export */}
            <AnalyticsHeader 
                timeRange={timeRange} 
                setTimeRange={setTimeRange} 
                handleExport={handleExport}
                isExporting={isExporting}
            />

            {/* Metric Overview Grid */}
            <KPIStatsGrid metrics={metrics} />

            {/* Performance Visualization Grid */}
            <ChartsGrid trends={trends} />

            {/* Team Performance Ranking */}
            <PerformersTable team={team} loading={loading} />

            {/* Error Notification */}
            {error && (
                <div className="fixed bottom-4 right-4 bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-xl shadow-lg text-sm font-medium z-50 flex items-center gap-2">
                    <AlertTriangle size={16} /> {error}
                </div>
            )}
        </div>
    );
};

export default Analytics;
